import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteRecepcionesOrdenDeCompra extends Component {
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasRecepciones: [],
    subtotal: 0,
    totalImpuestos: 0,
    totalDescuento: 0,
    total: 0,
    totalInsumosRecibidos: 0,
    totalRecepciones: 0,
    totalOrdenesRecibidas: 0,
    totalPendientePorRecibir: 0,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proveedores/selectProveedores",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProveedores: res.data,
            objetoProveedores: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasUniadesDeNegocio: res.data,
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5
                ) +
                  " - " +
                  value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultarReporteRecepciones({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: 0,
      filtrarProyecto: 0,
    });
  }

  consultarReporteRecepciones(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeCompras/reporteRecepcionesOrdenDeCompra",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            dataReporte: res.data,
            todasRecepciones: res.data.recepciones,
            subtotal: res.data.subtotal,
            totalImpuestos: res.data.totalImpuestos,
            totalDescuento: res.data.totalDescuento,
            total: res.data.total,
            totalInsumosRecibidos: res.data.totalInsumosRecibidos,
            totalRecepciones: res.data.totalRecepciones,
            totalOrdenesRecibidas: res.data.totalOrdenesRecibidas,
            totalPendientePorRecibir: res.data.totalPendientePorRecibir,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "00BFD6" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const cellStyle = { alignment: { vertical: "center" }, border };
    const moneyStyle = {
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: '"$"#,##0.00',
      border,
    };

    const celda = (value, tipo) => {
      if (tipo === "money") {
        return { v: typeof value === "number" ? value : 0, s: moneyStyle };
      }
      return { v: value === null || value === undefined ? "" : value, s: cellStyle };
    };

    const columnasConfig = [
      { header: "Folio", key: "Folio", tipo: "texto" },
      { header: "Serie", key: "Serie", tipo: "texto" },
      { header: "Codigo Remision", key: "Codigo Remision", tipo: "texto" },
      { header: "Fecha", key: "Fecha", tipo: "texto" },
      { header: "Codigo Proveedor", key: "Codigo Proveedor", tipo: "texto" },
      { header: "Clave Proveedor", key: "Clave Proveedor", tipo: "texto" },
      { header: "Proveedor", key: "Proveedor", tipo: "texto" },
      { header: "Subtotal", key: "Subtotal", tipo: "money" },
      { header: "Impuestos", key: "Impuestos", tipo: "money" },
      { header: "Descuento", key: "Descuento", tipo: "money" },
      { header: "Total", key: "Total", tipo: "money" },
      { header: "Cantidad Insumos Recibidos", key: "Cantidad Insumos Recibidos", tipo: "texto" },
      { header: "Pendiente Por Recibir", key: "Pendiente Por Recibir", tipo: "texto" },
    ];

    const datosDescargar = this.state.todasRecepciones.map((valueRecepcion) => ({
      Folio: valueRecepcion.folio,
      Serie: valueRecepcion.serie,
      "Codigo Remision": valueRecepcion.codigoRemision,
      Fecha: valueRecepcion.fecha,
      "Codigo Proveedor": valueRecepcion.codigoProveedor,
      "Clave Proveedor": valueRecepcion.claveProveedor,
      Proveedor: valueRecepcion.proveedor,
      Subtotal: valueRecepcion.subtotal,
      Impuestos: valueRecepcion.impuestos,
      Descuento: valueRecepcion.descuento,
      Total: valueRecepcion.total,
      "Cantidad Insumos Recibidos": valueRecepcion.cantidadInsumosRecibidos,
      "Pendiente Por Recibir": valueRecepcion.pendientePorRecibir,
    }));

    const rows = [
      columnasConfig.map((columna) => ({ v: columna.header, s: headerStyle })),
      ...datosDescargar.map((fila) =>
        columnasConfig.map((columna) => celda(fila[columna.key], columna.tipo))
      ),
    ];

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!cols"] = columnasConfig.map((columna) => ({
      wch: Math.max(columna.header.length + 2, 12),
    }));
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Recepciones Orden de Compra");
    XLSXStyle.writeFile(workbook, "Reporte_RecepcionesOrdenesCompra.xlsx");
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const esValorVacio = (v) =>
      v === undefined || v === null || v === "" || (typeof v === "number" && isNaN(v));
    const columns = [
      {
        title: "Folio",
        key: "folio",
        sorter: (a, b) => (a.folio < b.folio ? -1 : a.folio > b.folio ? 1 : 0),
        buscar: "folio",
        ellipsis: true,
        render: (_, record) => {
          if (esValorVacio(record.folio)) return "";
          const serie = esValorVacio(record.serie) ? "" : record.serie;
          return serie ? `${record.folio} - ${serie}` : `${record.folio}`;
        },
      },
      {
        title: "Codigo Remision",
        dataIndex: "codigoRemision",
        key: "codigoRemision",
        buscar: "codigoRemision",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        sorter: (a, b) =>
          moment(a.fecha, "DD/MM/YYYY") < moment(b.fecha, "DD/MM/YYYY")
            ? -1
            : moment(a.fecha, "DD/MM/YYYY") > moment(b.fecha, "DD/MM/YYYY")
            ? 1
            : 0,
        buscar: "fecha",
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        sorter: (a, b) => (a.proveedor < b.proveedor ? -1 : a.proveedor > b.proveedor ? 1 : 0),
        buscar: "proveedor",
        ellipsis: true,
      },
      {
        title: "Subtotal",
        dataIndex: "subtotal",
        key: "subtotal",
        sorter: (a, b) => a.subtotal - b.subtotal,
        buscar: "subtotal",
        ellipsis: true,
        render: (value) => (esValorVacio(value) ? "" : dineroDisabledMask(value)),
        align: "right",
      },
      {
        title: "Impuestos",
        dataIndex: "impuestos",
        key: "impuestos",
        sorter: (a, b) => a.impuestos - b.impuestos,
        ellipsis: true,
        render: (value) => (esValorVacio(value) ? "" : dineroDisabledMask(value)),
        align: "right",
      },
      {
        title: "Descuento",
        dataIndex: "descuento",
        key: "descuento",
        sorter: (a, b) => a.descuento - b.descuento,
        ellipsis: true,
        render: (value) => (esValorVacio(value) ? "" : dineroDisabledMask(value)),
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: (a, b) => a.total - b.total,
        buscar: "total",
        ellipsis: true,
        render: (value) => (esValorVacio(value) ? "" : dineroDisabledMask(value)),
        align: "right",
      },
      {
        title: "Cantidad Insumos Recibidos",
        dataIndex: "cantidadInsumosRecibidos",
        key: "cantidadInsumosRecibidos",
        sorter: (a, b) => a.cantidadInsumosRecibidos - b.cantidadInsumosRecibidos,
        ellipsis: true,
        align: "right",
      },
      {
        title: "Pendiente Por Recibir",
        dataIndex: "pendientePorRecibir",
        key: "pendientePorRecibir",
        sorter: (a, b) => a.pendientePorRecibir - b.pendientePorRecibir,
        ellipsis: true,
        align: "right",
      },
    ];
    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteRecepcionesOrdenDeCompra"
          onFinish={this.consultarReporteRecepciones.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Recepciones de Orden de Compra"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                  <FormItem name="proveedores" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Proveedores">
                      {this.state.objetoProveedores}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem width="90%" placeholder="Proyectos" mode="multiple">
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem width="90%" placeholder="Unidades de Negocio">
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Recepciones</p>
                  <h1 style={{ fontSize: 15 }}>{this.state.totalRecepciones}</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Ordenes Recibidas</p>
                  <h1 style={{ fontSize: 15 }}>{this.state.totalOrdenesRecibidas}</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Insumos Recibidos</p>
                  <h1 style={{ fontSize: 15 }}>{this.state.totalInsumosRecibidos}</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Pendiente Por Recibir</p>
                  <h1 style={{ fontSize: 15 }}>{this.state.totalPendientePorRecibir}</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total</p>
                  <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(this.state.total)}</h1>
                </Col>
              </Row>
            </div>
            <TableItem
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasRecepciones}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteRecepcionesOrdenDeCompra);
